import * as React from 'react';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import { styled } from '@mui/material/styles';

const FormWrapper = styled('div')(() => ({
  margin: '0',
  padding: '0',
  overflow: 'inherit',
}));

const StyledCard = styled(Card)(() => ({
  boxShadow: 'none',
  borderRadius: 0,
}));

const StyledHeader = styled(CardHeader)(() => ({
  padding: '10px 10px 10px 20px',
  background: '#f2f2f2',
  color: '#000000',
  fontSize: '0.85028rem',
  fontWeight: 500,
}));

const StyledContent = styled(CardContent)(() => ({
  '& .MuiPaper-elevation1': {
    boxShadow: '0 0 0 0',
  },
  padding: '20px',
  fontSize: '0.8rem',
  minHeight: '230px',
}));

export interface SettingsCardProps {
  title: string;
  children?: React.ReactNode;
}

export const CommonCard = ({ title, children }: SettingsCardProps) => {
  return (
    <FormWrapper>
      <StyledCard>
        <StyledHeader title={title} disableTypography />
        <StyledContent>{children}</StyledContent>
      </StyledCard>
    </FormWrapper>
  );
};
